import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations, LANGUAGES } from "../lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "bg";
    const saved = window.localStorage.getItem("lawsn.lang");
    if (saved && translations[saved]) return saved;
    const browser = (navigator.language || "").slice(0, 2).toLowerCase();
    return translations[browser] ? browser : "bg";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("lawsn.lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.bg,
      languages: LANGUAGES,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
